export default "__VITE_ASSET__BE7jgYe7__"